<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>{{$route.meta.title}}</h3>

      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: '后台用户管理' }">后台用户管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <template #header>表单</template>
      <el-form ref="form"
               :model="dataModel"
               :rules="formRules"
               label-width="160px"
               @submit.native.prevent="onSubmit()">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item prop="customerid"
                          label="客户:">
              <el-select
                v-model="dataModel.customerid"
                :remote-method="onSearchCustomers"
                @visible-change="onChangeCustomerVisible"
                @change="onChangeCustomerId"
                :loading="inLoading.customerid"
                size="small"
                class="width-max"
                multiple
                filterable
                remote
                clearable>
                <el-option
                  v-for="item in optionModel.customers"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="adminuser"
                          label="管理员:">
              <el-radio v-model="findBy" label="department">按部门选择</el-radio>
              <el-radio v-model="findBy" label="search">按搜索选择</el-radio>
              <div style="padding-bottom: 100px">
                <el-cascader
                  :options="departments"
                  v-model="selectedDepartmentUsers"
                  size="small"
                  class="width-max"
                  v-show="findBy === 'department'"
                  :props="{multiple: true, lazy: true, lazyLoad: lazyLoadAdminUsers}" />
                <el-select
                  v-model="dataModel.adminuser"
                  v-show="findBy === 'search'"
                  :remote-method="onSearchAdminusers"
                  @visible-change="onChangeAdminuserVisible"
                  @change="onChangeAdminuser"
                  placeholder="请输入关键词进行搜索"
                  class="width-max"
                  :loading="inLoading.adminuser"
                  size="small"
                  multiple
                  filterable
                  remote>
                  <el-option
                    v-for="item in optionModel.adminusers"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item>
              <el-button type="primary"
                         native-type="submit">保存
              </el-button>
              <el-button @click="$router.push({name: '后台用户管理'})">取消
              </el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </layout-panel>
  </div>
</template>

<script>
export default {
  data () {
    return {
      inputWith: 12,
      findBy: 'department',
      formRules: {
        customerid: [
          {type: 'array', required: true, message: '客户不能为空', trigger: 'blur'},
        ],
        adminuser: [
          {type: 'array', required: true, message: '管理员不能为空', trigger: 'blur'},
        ],
      },

      dataModel: {
        customerid: [],
        adminuser: [],
      },
      selectedDepartmentUsers: [],

      optionModel: {
        customers: [],
        adminusers: [],
      },

      inLoading: {
        customerid: false,
        adminuser: false,
      },
      departments: [],
    }
  },
  created () {
    request.common('getDepartmentsIndex', {current_page: 1, per_page: 500}).then(({data}) => {
      this.departments = data.data.map(it => ({
        label: it.name,
        value: it.id
      }))
    })
  },
  methods: {
    onSearchCustomers (val = '') {
      if (val) {
        this.inLoading.customerid = true

        request.alert('getCustomerTable', {
          keyword: val,
          type: [10, 70], // 仅支持搜索大客户、爱绩效客户
        }).then(({data}) => {
          this.inLoading.customerid = false
          this.optionModel.customers = data.data
        }).catch(() => {
          this.inLoading.customerid = false
        })
      } else {
        this.optionModel.customers = []
      }
    },


    onSearchAdminusers (val = '') {
      if (val) {
        this.inLoading.adminuser = true

        request.alert('getBasicPlatformUsersIndex', {
          name: val,
          status: [1, 2],
        }).then(({data}) => {
          this.inLoading.adminuser = false
          this.optionModel.adminusers = data.data
        }).catch(() => {
          this.inLoading.adminuser = false
        })
      } else {
        this.optionModel.adminusers = []
      }
    },


    onChangeCustomerId () {
      this.optionModel.customers = []
    },


    onChangeAdminuser () {
      this.optionModel.adminusers = []
    },


    onChangeCustomerVisible (isShow) {
      if (isShow) return
      this.optionModel.customers = []
    },


    onChangeAdminuserVisible (isShow) {
      if (isShow) return
      this.optionModel.adminusers = []
    },
    getForm () {
      const result = filter.copyJson(this.dataModel)
      result.adminuser = this.getSelectedAdminuserIds()

      return result
    },
    getSelectedAdminuserIds () {
      if (this.findBy === 'search') {
        return this.dataModel.adminuser
      }
      return this.selectedDepartmentUsers.map(it => it[1]).filter(it => !!it)
    },
    onSubmit () {
      const validator = this.findBy === 'department'
        ? (func) => func(true)
        : this.$refs.form.validate
      validator((valid) => {
        if (!valid) {
          this.$message.error('提交内容填写不正确！')
          return
        }
        const form = this.getForm()
        if (form.adminuser.length <= 0) {
          this.$message.error('请选择管理员！')
          return
        }
        if (form.customerid.length <= 0) {
          this.$message.error('请选择客户！')
          return
        }

        request.common('AllotPlatformUserMany', this.getForm()).then(() => {
          this.$message.success('分配成功')
          this.$router.replace({name: '后台用户管理'})
        })
      })
    },
    lazyLoadAdminUsers (node, resolve) {
      if (node.root || node.data.leaf) {
        resolve([])
        return
      }
      request.common('getBasicPlatformUsersIndex', {
        current_page: 1,
        per_page: 1000,
        usertype: [2, 3],
        status: [1, 2],
        department_id: node.data.value
      }).then(({data}) => {
        resolve(data.data.map(it => ({
          label: it.name,
          value: it.id,
          leaf: true,
        })))
      })
    }
  },
}
</script>


<style lang="scss"
       scoped
       src="../style/PlatformUser.scss"></style>



// WEBPACK FOOTER //
// src/views/platform-user/pages/PlatformUserAllotManyForm.vue